import { c as _c } from "react/compiler-runtime";
import { useMemo } from "react";

/**
 * Maps a user-typed search term to a Set of matching param constants.
 *
 * Used to drive field visibility in the project table's two search-driven
 * menus:
 *
 * - **ProjectFilters panel** — hides filter rows (Job No., Stage, Type, Client,
 *   Owner, Architect, dates, Location) whose param isn't in the returned Set.
 * - **ProjectSortMenu** — hides sort rows by the same mechanism.
 *
 * Behavior:
 * - Empty / whitespace `searchTerm` → all params visible (Set contains every
 *   key in the map).
 * - Non-empty `searchTerm` → only params whose keywords start with the normalised
 *   term (case-insensitive) are included.
 * - Empty returned Set → no matches; the caller should render an empty state.
 *
 * @param searchTerm The current value of the menu's search input.
 */
export function useFilterPanelFieldSearch(fieldMap, searchTerm) {
  const $ = _c(5);
  let t0;
  if ($[0] !== fieldMap || $[1] !== searchTerm) {
    bb0: {
      const normalized = searchTerm?.trim().toLowerCase();
      if (!normalized) {
        let t1;
        if ($[3] !== fieldMap) {
          t1 = new Set(Object.keys(fieldMap));
          $[3] = fieldMap;
          $[4] = t1;
        } else {
          t1 = $[4];
        }
        t0 = t1;
        break bb0;
      }
      const matching = new Set();
      for (const [param, keywords] of Object.entries(fieldMap)) {
        if (keywords.some(keyword => keyword.startsWith(normalized))) {
          matching.add(param);
        }
      }
      t0 = matching;
    }
    $[0] = fieldMap;
    $[1] = searchTerm;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}